module.exports = __webpack_public_path__ + "static/img/jhg1.3e2ed46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/jhg1.png
// module id = HrOP
// module chunks = 0